module.exports = __webpack_public_path__ + "static/media/image9-min.5f0dfccf.jpg";